export default __webpack_public_path__ + "static/media/aplicativo-dashboard.a7eaabb4.png";